import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useReviewsSection} from '../../useGetProductBulkSection';
import {PriceAndBrandReviewsSectionView} from './PriceAndBrandReviewsSectionView.eager';
import {Skeleton} from './Skeleton';

export const PriceAndBrandReviewsSection = () => {
  return (
    <DataFetcher
      request={useReviewsSection()}
      Error={() => null}
      Loading={Skeleton}
      View={PriceAndBrandReviewsSectionView}
    />
  );
};
